<template>
  <div v-if="this.$store.state.auth.isLogged">
    <button
      class="button back"
      @click="gotoadmin"
    >
      <b-icon
        class="queueicon"
        pack="fas"
        icon="chevron-left"
        size="is-small"
      ></b-icon>
    </button>
  </div>
</template>

<script>

export default {
  name: 'backToAdmin',
  data: function () {
    return {
    }
  },
  methods: {
    gotoadmin: function (event) {
      this.$router.push({ name: 'Admin' })
    }
  }
}
</script>

<style scoped>
.back {
  float: left;
  margin: 0px;
  font-size: 18px;
  background-color: rgba(0, 0, 0, 0);
  color: #f8df40;
  border: none;
}
@media (max-width: 1025px) {
  #retourtexte {
    display: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/board/backToAdmin.vue